
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import {formatDate} from "@/javascript/formatDate"
import payPublic from '@/javascript/payPublic'
import Clipboard from 'clipboard'
import Swiper from 'swiper'
import goMini from '@/components/lyx-components/go-mini/index.vue'
import util from '@/javascript/util'
import axios from "axios"
import goBack from '@/components/public-components/goBack/index.vue'

export default {
components: {
Tab,
TabItem,
Previewer,
Confirm,
goMini,
goBack
},
data() {
return {
minHeight: 0,
tabIndex: 0,
tabData: ['全部', '待付款', '已付款', '退款'],
mainOrderId: this.$route.params.mainOrderId,
orderId: this.$route.params.orderId,
orderType: this.$route.params.orderType,
ticketInfo: '',
scienceData: '',
totalNum: '',
showTime: true,
CloseTimer: {},
min: 0,
sec: 0,
week: '',
showImage: '',
province: '',
imageList: [],
customers: [],
cancelConfirm: false,
deleteConfirm: false,
ticketReturnRule: {},
showMore: false,
changeText: true,
isWeiXin: util.isWeiXin(),
lng: '',
lat: '',
formattedAddress: '',
qrCodeList: [],
qrCode: '',
}
},
mounted() {
const _this = this
document.title = "订单详情"
_this.minHeight = document.documentElement.clientHeight

/**
* 微信签名分享
*/
if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: _this.PAGE_TITLE,
desc: _this.SHARE_TEXT,
imgUrl: _this.SHARE_IMG,
link: window.location.href.split('#')[0]
} : shareData;

_this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + _this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}

if (payPublic.isClient()) {
payPublic.hasToken(function () {
const noLogin = localStorage.getItem('noLogin')
if (!noLogin) {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.publicWay(userInfo)
} else {
payPublic.goBack()
}
})
} else {
payPublic.loginCheck(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.publicWay(userInfo)
})
}
},
methods: {
againPay(){
this.$router.push({path: '/scenicView/' + this.scienceData.scenicEntity.id})
},
callPhone() {
if(this.customers.length > 0 && this.customers[0].contactNumber && this.customers[0].contactNumber != "暂无"){
payPublic.callPhone(this.customers[0].contactNumber)
}else{
payPublic.showPrompt('暂无电话')
}
},
refundPage(){
this.$router.push({path: '/refundProduct/' + this.mainOrderId + '/' + this.orderId + '/1/1'})
},
goSpot() {
this.$router.push({path: '/scenicView/' + this.scienceData.scenicEntity.id})
},
publicWay(info){
const _this = this
_this.$http.get('/api/wtcp-ecrm/comOrderClient/getTicketDetail?access_token=' + info.access_token + '&mainOrderId=' + _this.mainOrderId + '&orderId=' + _this.orderId).then(res => {
const data = res.data.data
if(data.checkMode == 0){
_this.qrCodeList = data.visitors
}else if(data.checkMode == 1){
_this.qrCodeList.push({checkQrCode: data.checkQrCode})
}
if(data.orderExpiredTime > 0){

_this.min = parseInt(data.orderExpiredTime/60)

_this.sec = data.orderExpiredTime%60
}
if (data.visitDate) {
data.visitDate = formatDate(data.visitDate, 'yyyy-MM-dd')
}
if(data.verifyType === 4 || data.verifyType === 5 || data.verifyType === 7){
data.comName = data.alias
}else if(data.verifyType === 1 || data.verifyType === 2 || data.verifyType === 6){
_this.ticketReturnRule = data.ticketReturnRule.returnRule
}
_this.ticketInfo = data
}).then(() => {
if(_this.ticketInfo.usePattern && _this.$refs.useHeight){
if(_this.$refs.useHeight.offsetHeight > 250){
_this.showMore = true
}
}
if(_this.qrCodeList.length > 0){
_this.qrCodeList.map(item => {
_this.imageList.push({src: 'data:image/png;base64,' + item.checkQrCode})
})
_this.$nextTick(() => {
new Swiper('.code-swiper', {
prevButton:'.swiper-button-prev',
nextButton:'.swiper-button-next',
})
})
}

_this.$http.get('/api/wtcp-ecrm/public/service/customer/list?type=2&contactType=3&merchantId=' + _this.ticketInfo.bsId).then((res) => {
const data = res.data.data
_this.customers = data
})

_this.week = this.getWeek(_this.ticketInfo.priceTime)
if(_this.ticketInfo.checkQrCode) {
_this.imageList = [{
src: 'data:image/png;base64,' + _this.ticketInfo.checkQrCode
}]
}
_this.CloseTimer = setInterval(function(){
_this.changeSec()
},1000);
_this.$http.get('/api/wtcp-bics/public/scenic/getOne/' + _this.ticketInfo.relativeId).then(res => {
const data = res.data.data
if (data.scenicEntity.summerTime) {
data.scenicEntity.summerTime = data.scenicEntity.summerTime.split(',')
}
if (data.scenicEntity.winterTime) {
data.scenicEntity.winterTime = data.scenicEntity.winterTime.split(',')
}
_this.scienceData = data
}).then(() => {

if(_this.scienceData.scenicEntity.regionFullName && _this.scienceData.scenicEntity) {
let pro = _this.scienceData.scenicEntity.regionFullName
_this.province = pro.replace(/,/g, "")
}

if(_this.scienceData.fileList.image.all.materials.length > 0){
_this.showImage = _this.scienceData.fileList.image.all.materials[0].fileUrl
}
const map = new AMap.Map('allMap', {
resizeEnable: false,
zoomEnable:false,
dragEnable: false,
zoom: 16,
center: [_this.scienceData.scenicEntity.longitude, _this.scienceData.scenicEntity.latitude]
});
const marker = new AMap.Marker({
image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
imageSize: new AMap.Size(135, 40),
position: [_this.scienceData.scenicEntity.longitude, _this.scienceData.scenicEntity.latitude],
offset: new AMap.Pixel(-13, -30)
});
marker.setMap(map);

map.on('click', function(e){
if(_this.THE_CLIENT){
const param = {
title: _this.scienceData.scenicEntity.title,
lng: _this.scienceData.scenicEntity.longitude,
lat: _this.scienceData.scenicEntity.latitude
}
payPublic.navigation(param)
}else{
window.location.href = "http://api.map.baidu.com/direction?origin=latlng:" + _this.lat + "," + _this.lng + "|name:我的起点&destination=latlng:" + _this.scienceData.scenicEntity.latitude + "," + _this.scienceData.scenicEntity.longitude + "|name:" + _this.scienceData.scenicEntity.title + "&region=" + _this.formattedAddress + "&mode=driving&output=html&coord_type=gcj02&src=zhjy"
}
})
})
})
},
changeSec(){
if(this.min > 0){
this.sec -= 1
if(this.min >0){
if(this.sec == 0){
this.sec = 59
this.min -=1
}
}
}else if(this.min == 0){
this.sec -= 1
if(this.sec == 0){
this.sec = 0
clearTimeout(this.CloseTimer)
this.showTime = false
this.ticketInfo.orderStatus = 3
}
}
},
getWeek(dateString) {
var dateArray = dateString.split("-");
var date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
return "周" + "日一二三四五六".charAt(date.getDay());
},
goTicket() {
this.$router.push({path: '/ticketReservation?scenicId=' + this.ticketInfo.relativeId + '&ticketId=' + this.ticketInfo.commodityId})
},
cancelOrder() {
this.cancelConfirm = true
},
cancelOK() {
const _this = this
if (payPublic.isClient()) {
payPublic.hasToken(function () {
const noLogin = localStorage.getItem('noLogin')
if (!noLogin) {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.cancelOne(userInfo)
} else {
payPublic.goBack()
}
})
} else {
payPublic.loginCheck(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.cancelOne(userInfo)
})
}
},
cancelOne(info){
const _this = this
_this.$http.get('/api/wtcp-ecrm/order/common/cancer?access_token=' + info.access_token + '&id=' + _this.mainOrderId ).then(res => {
if (res.data.data) {
_this.ticketInfo.orderStatus = 3
}
})
},
deleteOrder() {
this.deleteConfirm = true
},
deleteOK() {
const _this = this
if (payPublic.isClient()) {
payPublic.hasToken(function () {
const noLogin = localStorage.getItem('noLogin')
if (!noLogin) {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.deleteOne(userInfo)
} else {
payPublic.goHome()
}
})
} else {
payPublic.loginCheck(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
_this.deleteOne(userInfo)
})
}
},
deleteOne(info){
axios({
method: "delete",
url: '/api/wtcp-ecrm/comOrderClient/deleteOrder?access_token=' + info.access_token + '&mainOrderId=' + this.mainOrderId + '&orderId=' + this.orderId + '&orderType=' + this.orderType,
}).then(res => {
if (res.data.data) {
this.$router.go(-1)
}
})
},
goEvaluation(item){
this.$router.push(`/evaluation/${item.relativeId}/${this.USE_TYPE_CODE.DS}/${this.EVAL_TYPE_CODE.JQ}/${item.supplierName}?orderId=${item.id}&commodityId=${item.commodityId}`)
},
goPay(){
let param = {
body: this.ticketInfo.comName,
disCountsMoney: this.ticketInfo.discountsAmount,
orderCode: this.ticketInfo.mainOrderCode,
payMoney: this.ticketInfo.total
}

this.$store.commit('changeCarlistFrom','')
this.$router.push({path: '/methodPay',query: param})
},
copy() {
var _this = this;
var clipboard = new Clipboard('#copy_text');

clipboard.on('success', e => {
payPublic.showPrompt('复制成功')

clipboard.destroy()
})
clipboard.on('error', e => {
payPublic.showPrompt('该浏览器不支持自动复制')

Message({
message: '该浏览器不支持自动复制',
type: 'warning'
});

clipboard.destroy()
})
},
showViewer (index) {
this.$refs.previewer.show(index)
},
onCancel() {},
showMoreText() {
this.changeText = !this.changeText
}
}
}
